export const formatPhoneNumber = (str: string | undefined): string => {
  if (!str || str.trim() === '') return "";
  if (str.length === 10) {
    return `(${str.substring(0, 3)}) ${str.substring(3, 6)}-${str.substring(6)}`;
  }
  return str;
}